/**
 * useRebookFormState — what the CSR has entered in the rebook drawer: the
 * chosen destination, the required reason, and the explicit cutoff opt-in
 * (BON-146).
 *
 * Separated from `useRebookBookingSubmit`, which owns the request and its
 * outcome. The split is a real seam, not a line-count dodge: this state
 * survives a failed submit untouched — that is the whole point of the retry
 * path — whereas the submission state is replaced on every attempt.
 */
import { useState } from 'react';

import type { PickerWorkshop } from './shared/pickerWorkshop';

export function useRebookFormState() {
  const [target, setTarget] = useState<PickerWorkshop | null>(null);
  const [reason, setReasonState] = useState('');
  const [overrideChecked, setOverrideChecked] = useState(false);
  const [reasonError, setReasonError] = useState<string | null>(null);

  return {
    target,
    reason,
    overrideChecked,
    setOverrideChecked,
    reasonError,
    setReasonError,
    setReason: (v: string) => {
      setReasonState(v);
      if (reasonError) setReasonError(null);
    },
    /** Choosing a destination — `onPicked` lets the caller drop a refusal that
     *  was about the workshop being replaced. */
    pickTarget: (workshop: PickerWorkshop, onPicked: () => void) => {
      setTarget(workshop);
      onPicked();
    },
  };
}
